import { PdfGen, PdfUnit, PdfSize, PdfRect, PdfPoint, PdfBrush, PdfFont } from '../../pdf/pdf';
import { ILayoutLabelGen } from '../layoutLabel';
import { IItemCount } from '@educraft/base';
import { OptsLabel } from '../optsLabel';
import { GUtil } from '../../pdf/gutil';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/image';
import '../../pdf/draw/label';

/**
 * Tabulka_100 (Table 100) - 10×10 number grid with image replacements
 *
 * Layout: 8 portrait pages. Top: 10×10 grid showing numbers 1-100,
 * with some numbers replaced by images from the input list.
 * Bottom: legend showing which images replace which numbers.
 * Pages 1-2: 1 image per 10 cells, Pages 3-4: 2 per 10, etc.
 *
 * Migrated from C# EduFrame.Img10.Generators.Tabulka_100
 */
export class Tabulka100 implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 10;
  }
  countMax(): number {
    return 10;
  }

  public async generate(pdf: PdfGen, opts: OptsLabel): Promise<void> {
    const margin = PdfUnit.FromMillimeters(20);
    const cellSize = (PdfSize.A4.width - 2 * margin) / 10;
    const size = { width: cellSize, height: cellSize };
    const originX = margin;
    const originY = margin;

    const pageCount = 4;

    for (let page = 0; page < pageCount; page++) {
      const pg = pdf.addPage();
      const count = page + 1;

      // Pick random cell positions to replace with images
      const allIndices = Array.from({ length: 100 }, (_, i) => i + 1);
      const shuffled = allIndices.sort(() => opts.data.random.next(0, 2) - 1);
      const imagePositions = shuffled.slice(0, 10 * count);

      // Map position → image index (mod 10)
      const dictionary = new Map<number, number>();
      for (let i = 0; i < imagePositions.length; i++) {
        dictionary.set(imagePositions[i], i % 10);
      }

      // Draw 10×10 grid
      for (let x = 0; x < 10; x++) {
        for (let y = 0; y < 10; y++) {
          const index = y * 10 + x + 1;
          const r = new PdfRect(
            originX + x * size.width,
            originY + y * size.height,
            size.width,
            size.height
          );

          if (dictionary.has(index)) {
            const k = dictionary.get(index)!;
            if (k < opts.list.length) {
              pg.drawLabel(opts.list[k].left, { rect: r });
            }
          } else {
            pg.drawFillStringCenter(index.toString(), GUtil.baseFont, PdfBrush.Black, r);
          }

          pg.drawRectangle(GUtil.basePen, null, r);
        }
      }

      // Draw legend at bottom: 2 columns × 5 rows
      for (let col = 0; col < 2; col++) {
        for (let row = 0; row < 5; row++) {
          const imgIndex = col * 5 + row;
          if (imgIndex >= opts.list.length) continue;

          for (let c = 0; c <= count; c++) {
            const xx = col * 5 + c;
            const r = new PdfRect(
              originX + xx * size.width,
              PdfSize.A4.height - margin - 5 * size.height + row * size.height,
              size.width,
              size.height
            );

            if (c === 0) {
              pg.drawLabel(opts.list[imgIndex].left, { rect: r });
            }

            pg.drawRectangle(GUtil.basePen, null, r);
          }
        }
      }
    }
  }
}
